"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.218 3.414C2.595 2.602 3.432 2 4.492 2H10.3a.7.7 0 1 1 0 1.4H4.492c-.5 0-.85.272-1.004.604a.89.89 0 0 0 .19 1.03l2.026 2.058a.7.7 0 1 1-.998.982l-.405-.411-1.62-1.646a2.285 2.285 0 0 1-.463-2.603M9.341 9a.7.7 0 0 1 .7.7v2.338C10.041 13.161 9.086 14 8 14c-.967 0-1.82-.657-2.005-1.593a.7.7 0 0 1 1.373-.272c.047.235.286.465.632.465.395 0 .641-.291.641-.562V9.7a.7.7 0 0 1 .7-.7m4.689-7.03a.75.75 0 0 1 0 1.06l-11 11a.75.75 0 0 1-1.06-1.06l11-11a.75.75 0 0 1 1.06 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=FilterOffIcon16.js.map